// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, GlobalStyles, ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: { main: '#000000' },
    background: { default: '#1c1c1c' },
  },
});

const globalStyles = (
  <GlobalStyles
    styles={{
      body: {
        background: '#F6F4F1',
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        color: '#000',  // Changed to black for better text contrast on white bg
      },

      '@keyframes fadeIn': {
        from: { opacity: 0, transform: 'scale(0.8)' },
        to: { opacity: 1, transform: 'scale(1)' },
      },

      // Accessible focus: hide outline for mouse clicks, show for keyboard
      '*:focus:not(:focus-visible)': {
        outline: 'none',
        boxShadow: 'none',
      },
      '*:focus-visible': {
        outline: '2px solid #72faff',
        outlineOffset: '2px',
      },

      // Swiper navigation arrows
      '.swiper-button-next, .swiper-button-prev': {
        color: '#ccc',               // Customize arrow 
        filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.4))',
        '&:hover': {
          color: '#000000',             // Brighter on hover
        },
      },

      // Swiper pagination bullets (dots)
      '.swiper-pagination-bullet': {
        backgroundColor: '#ccc',       // default dot color (light gray)
        opacity: 1,
      },
      '.swiper-pagination-bullet-active': {
        backgroundColor: '#ffffff',    // active dot color (matching arrows)
      },
    }}
  />
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProvider>
  </BrowserRouter>
);